/* assets/quick-add-modal.js */
(() => {
  // Quick add butonları (Mio): data-variant varsa “add to cart” yapıyoruz
  const QUICK_ADD_SEL = '.js-product-card-quick-view-button, .product-card__quick-view-text-button, .product-card__quick-view-button';

  // Header sayaç (senin yapına göre)
  const COUNT_WRAPPER_SEL = '.js-header-cart-item-count-wrapper';
  const COUNT_TEXT_SEL    = '.js-header-cart-item-count';

  // Modal nodeları
  const modal = document.getElementById('atc-modal');
  const dlg   = modal?.querySelector('.atc-modal__dialog');
  const thumb = modal?.querySelector('.atc-modal__thumb');
  const pttl  = modal?.querySelector('.atc-modal__product-title');
  const pvar  = modal?.querySelector('.atc-modal__variant');
  const pprc  = modal?.querySelector('.atc-modal__price');

  // Quick add click
  document.addEventListener('click', async (e) => {
  const btn = e.target.closest(QUICK_ADD_SEL);
  if (!btn) return;

  const variantId = btn.dataset.variant || btn.dataset.variantId;
  if (!variantId) return; // varyant seçimi gerekiyorsa normal quick view çalışsın

  e.preventDefault();

  // Çift tıklama / peşpeşe istekleri engelle
  if (btn.dataset.loading === '1') return;
  btn.dataset.loading = '1';
  btn.setAttribute('disabled', 'disabled');

  try {
    const { item, cart } = await addToCartAndGet(variantId);
    // Başarılıysa:
    updateCartCount(cart?.item_count ?? 0);
    populateFromButtonOrItem(btn, item);
    openModal();
  } catch (err) {
    // Başarısızsa: modal **açma**, sadece hata toast
    toast(err?.message || 'Ürün sepete eklenemedi.');
  } finally {
    // Butonu geri aç
    delete btn.dataset.loading;
    btn.removeAttribute('disabled');
  }
});

  // Modal kapatma (backdrop/close/ESC)
  modal?.addEventListener('click', (e) => { if (e.target.matches('[data-atc-close]')) closeModal(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) closeModal(); });

  // ---- Core ----
            async function addToCartAndGet(variantId) {
            const addRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 })
            });
  if (!addRes.ok) {
    // Shopify genelde 422 + { description: "...", status: 422 } döner
    let errJson = null;
    try { errJson = await addRes.json(); } catch {}
    const msg =
      errJson?.description ||
      errJson?.message ||
      (addRes.status === 422 ? 'Bu ürün için izin verilen maksimum adede ulaştınız.' : 'Ürün sepete eklenemedi.');
    const error = new Error(msg);
    error.status = addRes.status;
    throw error;
  }
  const item = await addRes.json();

  const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  const cart = await cartRes.json();
  document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  return { item, cart };
  }

  function updateCartCount(n) {
    const wrap = document.querySelector(COUNT_WRAPPER_SEL);
    if (wrap) wrap.setAttribute('data-cart-count', String(n));
    const txt = document.querySelector(COUNT_TEXT_SEL);
    if (txt) txt.textContent = String(n);
  }

  function populateFromButtonOrItem(btn, item) {
    // 1) Product-card’a ekleyeceğimiz data-* varsa öncelikli kullan
    const dsTitle = btn?.dataset?.productTitle;
    const dsImg   = btn?.dataset?.productImage;
    const dsUrl   = btn?.dataset?.productUrl;

    // 2) Yoksa /cart/add.js item’ından doldur
    const title = dsTitle || item?.product_title || item?.title || 'Ürün';
    const variantText = item?.variant_title ? item.variant_title : '';
    const imgSrc = dsImg || item?.image || (item?.featured_image && item.featured_image.url);

    // Görsel
    if (thumb) {
      thumb.innerHTML = '';
      if (imgSrc) {
        const img = new Image();
        img.alt = '';
        img.decoding = 'async';
        img.loading = 'lazy';
        img.src = imgSrc;
        thumb.appendChild(img);
      }
    }

    // Metinler
    if (pttl) {
      if (dsUrl) pttl.innerHTML = `<a href="${dsUrl}" class="focus-visible-outline">${escapeHtml(title)}</a>`;
      else pttl.textContent = title;
    }
    if (pvar) pvar.textContent = variantText;

    if (pprc) {
      const unitPrice = typeof item?.price === 'number' ? (item.price / 100) : null;
      pprc.textContent = unitPrice ? formatMoney(unitPrice) : '';
    }
  }

  function formatMoney(n) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
        style: 'currency', currency: 'TL'
      }).format(n);
    } catch { return `${n.toFixed(2)} TL`; }
  }

  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }

  // Modal controls
  function isOpen(){ return modal?.getAttribute('aria-hidden') === 'false'; }
  function openModal(){
  if (!modal || !dlg) return;
  modal.setAttribute('aria-hidden', 'false');
  // animasyon akıcı olsun diye kısa gecikme ile focus
  setTimeout(() => firstFocusable(dlg)?.focus(), 50);
  // bottom sheet olduğundan body scroll’u kilitlemeyelim; çok istiyorsan aç:
  // document.body.style.overflow = 'hidden';
}
function closeModal(){
  if (!modal) return;
  modal.setAttribute('aria-hidden', 'true');
  // document.body.style.overflow = '';
}

  function firstFocusable(root){
    const sel = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const els = Array.from(root.querySelectorAll(sel)).filter(el => !el.hasAttribute('disabled') && isVisible(el));
    return els[0] || root;
  }
  function isVisible(el){ return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function toast(msg){
    let t = document.getElementById('atc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'atc-toast';
      Object.assign(t.style, {
        position:'fixed',left:'50%',bottom:'24px',transform:'translateX(-50%)',
        background:'rgba(30,30,30,.95)',color:'#fff',padding:'10px 12px',borderRadius:'8px',
        zIndex:10000,boxShadow:'0 6px 24px rgba(0,0,0,.25)',fontSize:'14px'
      });
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(toast._t);
    toast._t = setTimeout(()=>{ t.style.opacity='0'; }, 2200);
  }
})();
